// extracted by mini-css-extract-plugin
export var btnDiv = "SectionSignupForm-module--btnDiv--b5fc9";
export var closeButton = "SectionSignupForm-module--closeButton--51b91";
export var modalContent = "SectionSignupForm-module--modalContent--d0c27";
export var modalOverlay = "SectionSignupForm-module--modalOverlay--0417a";